export default "__VITE_ASSET__cxSUsFzr__"